import { shade, tint, transparentize, readableColor, adjustHue, setHue } from 'polished';
import { memoizedGet } from './object.esm.js';

function getSafeShade(percentage, color) {
  try {
    return shade(percentage, color);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("----- unable to resolve shade of color ".concat(color, " ----"));
    return color;
  }
}
function getSafeTint(percentage, color) {
  try {
    return tint(percentage, color);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("----- unable to resolve tint of color ".concat(color, " ----"));
    return color;
  }
}
function getSafeTransparentize(amount, color) {
  try {
    return transparentize(amount, color);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("----- unable to resolve transparentize of color ".concat(color, " ----"));
    return color;
  }
}

// get readable color based on the background color
function getSafeReadableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
  try {
    return readableColor(color, returnIfLightColor, returnIfDarkColor, strict);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("----- unable to resolve readable color of color ".concat(color, " ----"));
    return color;
  }
}
function getSafeColor(color, theme) {
  var fallBackColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#fff';
  if (theme && 'colors' in theme) {
    return memoizedGet(theme, "colors.".concat(color), fallBackColor);
  }
  return fallBackColor;
}
function setSafeAdjustHue(hue, color) {
  try {
    return adjustHue(hue, color);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("----- unable set hue color ".concat(color, " ----"));
    return color;
  }
}
function setSafeHue(hue, color) {
  try {
    return setHue(hue, color);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("----- unable set hue color ".concat(color, " ----"));
    return color;
  }
}

export { getSafeColor, getSafeReadableColor, getSafeShade, getSafeTint, getSafeTransparentize, setSafeAdjustHue, setSafeHue };
//# sourceMappingURL=colors.esm.js.map
